<template>
  <div class="container" ref="container">

    <div class="wrap-tips" @click="showRankRule">
      <div class="tips">排行说明</div>
    </div>

    <template v-if="result && result.length">
      <!-- 图文类型风格 -->
      <div class="list picture" v-if="isPicture && result.length>3">
        <div class="top">
          <div :class="['rank', 'rank'+(index+1)]" v-for="(item, index) in result" :key="item.id" v-if="index<3"
               @click="showMore" :data-oid="item.id">
            <div class="avatar" :style="{backgroundImage: 'url('+item.image_url+')'}"></div>
            <div class="content">
              <div :class="['no', 'no' + (index + 1)]"></div>
              <div class="name">{{ item.text }}</div>
              <div class="count">{{ item.count || 0 }}票</div>
              <div class="text">查看详情</div>
              <div class="btn" v-if="showCanvass" @click.stop="toCanvass" :data-oid="item.id">拉票</div>
            </div>
          </div>
        </div>
        <div class="item" v-for="(item, index) in result" :key="item.id" v-if="index>=3" @click="showMore"
             :data-oid="item.id">
          <div class="no">{{ index + 1 }}</div>
          <div class="info">
            <div class="avatar" :style="{backgroundImage: 'url('+item.image_url+')'}"></div>
            <div class="name">{{ item.text }}</div>
            <div class="count">{{ item.count || 0 }}票</div>
          </div>
          <div class="canvass" v-if="showCanvass">
            <div class="btn-canvass" @click.stop="toCanvass" :data-oid="item.id">拉票</div>
          </div>
        </div>
      </div>

      <!-- 普通类型风格 and PK -->
      <div v-else :class="['list', 'normal', type==3 ? 'pk' : '']">
        <div class="item" v-for="(item, index) in result" :key="item.id" @click="showMore" :data-oid="item.id">
          <div :class="['no', 'no' + (index + 1)]">{{ index + 1 }}</div>
          <div class="info">
            <div class="name">{{ item.text }}</div>
            <div class="wrap-progress">
              <div class="values">
                <div class="rate">{{ item.percent || 0 }}%</div>
                <div class="count">{{ item.count || 0 }}票</div>
              </div>
              <van-progress class="progress" :percentage="item.percent || 0" color="#1890FF" stroke-width="6"
                            track-color="#EAEAEA" :show-pivot="false"/>
            </div>
          </div>
          <div class="canvass" v-if="showCanvass" @click.stop="toCanvass" :data-oid="item.id">
            <div class="btn-canvass">拉票</div>
          </div>
        </div>
      </div>
    </template>
    <van-empty v-else class="empty-image" description="暂无数据"
               image="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-06-12/460216f153172a54b4e4fc2bd412e91e.png"/>

    <div class="footer">
      <button class="btn btn-share">分享</button>
      <!--      <div class="btn btn-download" v-if="is_owner" @click="exportData">-->
      <!--        <div class="download">下载</div>-->
      <!--      </div>-->
      <div class="btn btn-vote">
        <div class="vote" @click="toDetail">去投票</div>
      </div>
    </div>

    <van-dialog
      class-name="rule-dialog"
      title="排名规则"
      v-model="ruleShow"
      confirmButtonText="我知道了"
      confirmButtonColor="#000"
      closeOnClickOverlay
      transition="none"
      @close="closeRankRule"
    >
      <div class="rules" v-if="type==3">
        <div class="num" data-num="1.">投票在红方与蓝方之间进行；</div>
        <div class="num" data-num="2.">最终票数高的一方为获胜方，若双方票数相同，则为平局；</div>
      </div>
      <div class="rules" v-else>
        <div class="num" data-num="1.">票数高者排名靠前；</div>
        <div class="num" data-num="2.">若票数相同，先达到该票数的用户排名靠前(以系统记录的“首次达到最高票数时间”为准)；
        </div>
        <div class="mt">结果：排行榜不会出现并列名次，一定有唯一的第 1 名、第 2 名…</div>
      </div>
    </van-dialog>

  </div>
</template>

<script>
import http from '@/utils/request';
import {getToken} from "@/utils/common";

export default {
  data() {
    return {
      ruleShow: false,
      loadingMore: false,
      hasMore: true,
      page: 1,
      count: 20,
      vid: '',
      type: '',
      result: null,
      isPicture: false,
      is_owner: false,
      showDev: false,
      showCanvass: false
    }
  },
  mounted() {
    const opt = this.$route.query

    // 投票类型, 0:普通投票(选项无图), 1:普通投票(选项有图), 2:活动投票, 3:二选一
    const isPicture = ['1', '2'].includes(opt.type + '')

    this.vid = opt.vid
    this.type = opt.type
    this.isPicture = isPicture
    this.loadResult()
    window.scrollTo(0, 0)
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (this.debounceTimer) clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.checkReachBottom();
      }, 300);
    },
    checkReachBottom() {
      const container = this.$refs.container;
      const {scrollTop, clientHeight, scrollHeight} = container;
      const isReachBottom = scrollTop + clientHeight >= scrollHeight - 1;

      if (isReachBottom) {
        this.loadResult();
      }
    },
    showMore: function (e) {
      const oid = e.currentTarget.dataset.oid;
      const vid = this.vid;
      const anonymous = this.anonymous;

      this.$router.push({
        path: "/all",
        query: {vid, oid, anonymous}
      });
    },
    showRankRule() {
      this.ruleShow = true
    },
    closeRankRule() {
      this.ruleShow = false
    },
    toCanvass(e) {
      const oid = e.currentTarget.dataset.oid;
      const vid = this.vid;

      this.$router.push({
        path: "/canvass",
        query: {vid, oid}
      });
    },
    backDetail() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace({
          path: '/detail',
          query: {vid: this.vid}
        });
      }
    },
    toDetail() {
      this.$router.replace({
        path: '/detail',
        query: {vid: this.vid}
      });
    },
    exportData() {
    },
    loadResult() {
      if (!this.hasMore || this.loadingMore) return;

      const {type, vid, page, count} = this
      const access_token = getToken()

      this.loadingMore = true

      http.get('/xvote/v2/users', {vid, page, count, access_token}).then(res => {
        if (res.data) {
          const data = res.data
          const newList = data.lists || []
          const result = this.result || []
          const arr = [...result, ...newList]

          // 老活动还是要前端排序 (二选一不用)
          if (data.opt_version != 1 && type != 3) {
            arr.sort((a, b) => (b.count - a.count))
          }

          this.loadingMore = false
          this.hasMore = newList.length === count
          this.page = page + 1
          this.result = arr
          this.is_owner = data.is_owner
          this.anonymous = data.anonymous
          this.showCanvass = data.is_canvas
        }
      }).catch(() => {
        this.loadingMore = false
      })
    }
  }

}

</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px / 75 + rem;
}

.container {
  position: relative;
  min-height: 100vh;

  &::before {
    z-index: 0;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: rem(524);
    background: linear-gradient(180deg, #C7E4FF 0%, rgba(255, 254, 244, 0) 100%);
  }

  view {
    box-sizing: border-box;
  }

  .no {
    word-break: break-all;

    &.no1 {
      text-indent: -9999em;
      background: url("https://cdn-xcxcustom.weiyoubot.cn/material/2025-08-13/ea541e6adcfe32e63e53df5eac737542.png") no-repeat center left;
      background-size: rem(44) rem(56);
    }

    &.no2 {
      text-indent: -9999em;
      background: url("https://cdn-xcxcustom.weiyoubot.cn/material/2025-08-13/e70e4c5aab4d55d0549d9714640f6fa5.png") no-repeat center left;
      background-size: rem(44) rem(56);
    }

    &.no3 {
      text-indent: -9999em;
      background: url("https://cdn-xcxcustom.weiyoubot.cn/material/2025-08-13/1c3cec4424df343f1d0f22f72012cdbc.png") no-repeat center left;
      background-size: rem(44) rem(56);
    }
  }

  .wrap-tips {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .tips {
    position: relative;
    font-size: rem(26);
    color: #999;
    padding: rem(22) rem(30) rem(14);
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &::before {
      content: "";
      display: block;
      width: rem(26);
      height: rem(26);
      margin-right: rem(12);
      background: url("https://cdn-xcxcustom.weiyoubot.cn/material/2025-08-13/2789f9311cbc31885c10c98fa1395727.png") no-repeat center;
      background-size: 100% 100%;
    }
  }

  .rules {
    color: #666666;
    font-size: rem(32);
    padding: rem(30) rem(70) rem(60);

    .num {
      display: flex;

      &::before {
        content: attr(data-num);
        flex: 0 0 rem(40);
      }
    }

    .mt {
      margin-top: rem(40);
    }
  }

  .list {
    position: relative;
    padding: 0 rem(30);
    padding-bottom: calc(0.8rem + 1.6rem + env(safe-area-inset-bottom));

    .item {
      display: flex;

      & + .item {
        margin-top: rem(64);
      }

      .no {
        flex: none;
        width: rem(76);
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      .info {
        flex: 1;
        overflow: hidden;

        .name {
          font-size: rem(28);
          color: #333333;
          margin-bottom: rem(8);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .count {
          &::after {
            flex: none;
            display: inline-block;
            content: "";
            width: rem(10);
            height: rem(10);
            border-top: rem(1) solid #999;
            border-right: rem(1) solid #999;
            transform: rotate(45deg) translate(rem(-5), rem(-2));
            transform-origin: center;
            margin-left: rem(10);
          }
        }

        .wrap-progress {
          .values {
            display: flex;
            justify-content: space-between;
            font-size: rem(22);
            color: #999999;
          }

          .progress {
            width: 100%;

            .wx-progress-inner-bar {
              border-radius: rem(8);
            }
          }
        }
      }

      .canvass {
        flex: none;
        width: rem(120);
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;

        .btn-canvass {
          padding: 0;
          margin: 0;
          width: rem(80);
          height: rem(44);
          line-height: rem(44);
          text-align: center;
          font-size: rem(24);
          color: #fff;
          background: #1890FF;
          border-radius: rem(8);

          &::after {
            display: none;
          }
        }
      }
    }

    &.picture {
      .top {
        display: flex;
        flex-flow: row nowrap;
        margin-bottom: rem(30);

        .rank {
          width: calc((100% - 0.8rem / 3));
          display: flex;
          flex-direction: column;
          align-items: center;

          &.rank1 {
            order: 2;
            margin: 0 rem(30);

            .content {
              background: linear-gradient(0deg, rgba(255, 250, 219, 0) 0%, #FEE375 100%);
            }
          }

          &.rank2 {
            order: 1;
            margin-top: rem(56);

            .content {
              background: linear-gradient(0deg, rgba(255, 230, 200, 0) 0%, #FFCDD5 100%);

              .btn {
                background: #FD3C58;
              }
            }
          }

          &.rank3 {
            order: 3;
            margin-top: rem(106);

            .content {
              background: linear-gradient(0deg, rgba(238, 247, 255, 0) 0%, #FED59B 100%);

              .btn {
                background: #FF7514;
              }
            }
          }

          .avatar {
            z-index: 2;
            position: relative;
            width: rem(130);
            height: rem(130);
            border-radius: rem(12);
            border: rem(6) solid #FFFFFF;
            background-color: #eee;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          }

          .content {
            position: relative;
            margin-top: rem(-26);
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: rem(70) rem(2) rem(12);
            width: 100%;
            border-radius: 20px 20px 0px 0px;

            .no {
              z-index: 3;
              position: absolute;
              top: rem(-6);
              left: 0;
              width: rem(52);
              height: rem(66);

              &.no1,
              &.no2,
              &.no3 {
                background-size: rem(52) rem(66);
              }
            }

            .name,
            .count {
              color: #333;
              font-size: rem(28);
              text-align: center;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .text {
              color: #999;
              font-size: rem(22);
              margin: rem(18) 0 rem(6);
            }

            .btn {
              color: #fff;
              font-size: rem(24);
              padding: rem(4) rem(16);
              border-radius: rem(8);
              background: #C7A003;
              position: relative;

              &:before {
                content: '';
                position: absolute;
                top: rem(-20);
                left: rem(-20);
                right: rem(-20);
                bottom: rem(-20);
              }
            }
          }
        }
      }

      .item {
        & + .item {
          margin-top: rem(40);
        }

        .no {
          width: rem(66);
        }

        .info {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          overflow: hidden;

          .avatar {
            flex: none;
            width: rem(80);
            height: rem(80);
            background: #E2E2E2;
            border-radius: rem(8);
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          }

          .name {
            flex: 1;
            padding-left: rem(20);
            margin-bottom: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .count {
            flex: none;
            width: rem(100);
            font-size: rem(28);
            color: #1890FF;
            text-align: right;

            &::after {
              border-color: #1890FF;
            }
          }
        }

        .canvass {
          width: rem(100);
          align-items: center;
        }
      }
    }

    &.pk {
      .item {
        &:nth-child(1) {
          .no {
            background: none;
            position: relative;
            width: rem(100);

            &::after {
              content: "红方";
              z-index: 1;
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
              font-size: rem(24);
              text-indent: initial;
              color: #FC635D;
              background: #FFE1E1;
              padding: rem(3) rem(10);
              border-radius: rem(20);
            }
          }

          .wx-progress-inner-bar {
            background: #FC635D !important;
          }
        }

        &:nth-child(2) {
          .no {
            background: none;
            position: relative;
            width: rem(100);

            &::after {
              content: "蓝方";
              z-index: 1;
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
              font-size: rem(24);
              text-indent: initial;
              color: #1890FF;
              background: #E5F1FD;
              padding: rem(3) rem(10);
              border-radius: rem(20);
            }
          }

          .wx-progress-inner-bar {
            background: #1890FF !important;
          }
        }
      }
    }
  }

  .footer {
    z-index: 10;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: rem(2) solid #DDDDDD;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    background: #fff;
    padding: rem(18) rem(12);
    padding-bottom: calc(0.24rem + env(safe-area-inset-bottom));

    .btn {
      padding: 0 rem(9);
      margin: 0 rem(9);
    }

    .btn-share,
    .btn-download {
      flex: none;
      font-size: rem(24);
      color: #666;
      display: flex;
      flex-direction: column;
      align-items: center;

      &::before {
        content: "";
        display: block;
        width: rem(38);
        height: rem(38);
        margin-bottom: rem(12);
      }
    }

    .btn-share {
      background: none;
      line-height: 1;
      margin-left: rem(19);

      &::after {
        display: none;
      }
    }

    .btn-share::before {
      background: url("https://cdn-xcxcustom.weiyoubot.cn/material/2025-08-13/01375b12bddec83df4478a21c618e5d4.png") no-repeat center;
      background-size: rem(38) rem(38);
    }

    .btn-download::before {
      background: url("https://cdn-xcxcustom.weiyoubot.cn/material/2025-08-13/68ef7caef1ae1e8e1778c599331aa434.png") no-repeat center;
      background-size: rem(32) rem(36);
    }

    .btn-download {
      margin-right: rem(19);
    }

    .btn-vote {
      flex: 1;

      .vote {
        margin: 0;
        padding: 0;
        height: rem(80);
        line-height: rem(80);
        text-align: center;
        font-size: rem(30);
        color: #fff;
        background: #1890FF;
        border-radius: rem(8);
      }
    }
  }
}

.rule-dialog {
  width: rem(640);
}

.empty-image {
  /deep/ .van-empty__image {
    height: auto;

    /deep/ img {
      display: block;
      height: auto;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/result/result.vue